import React from "react";
import {
  jobListDisplayStatus,
  type JobListFilterRow,
} from "@toolkit/mobile-shared";
import { Badge } from "../ui/badge";
import { cn } from "../../lib/utils";

const STATUS_LABEL_CLASS: Record<string, string> = {
  Active:
    "bg-emerald-50 text-emerald-700 dark:bg-emerald-950/50 dark:text-emerald-300",
  Complete:
    "bg-slate-100 text-slate-700 dark:bg-slate-800/60 dark:text-slate-300",
  Archived: "bg-muted text-muted-foreground",
};

type JobListStatusChipProps = {
  job: JobListFilterRow;
  className?: string;
  /** When true, show an Active chip for sites that are not complete or archived. */
  showActiveLabel?: boolean;
};

export const JobListStatusChip: React.FC<JobListStatusChipProps> = ({
  job,
  className,
  showActiveLabel = false,
}) => {
  const label =
    jobListDisplayStatus(job) ?? (showActiveLabel ? "Active" : null);
  if (!label) return null;

  return (
    <Badge
      className={cn(
        "normal-case tracking-normal",
        STATUS_LABEL_CLASS[label] ?? STATUS_LABEL_CLASS.Active,
        className,
      )}
    >
      {label}
    </Badge>
  );
};

export { jobListDisplayStatus };
